import { I } from '@angular/cdk/keycodes';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  ChangeDetectorRef,
} from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'shared-globalProduit-form',
  templateUrl: './global-form.component.html',
  styleUrls: ['./global-form.component.css'],
})
export class SharedGlobalFormComponent implements OnInit, OnChanges {
  @Input() formBuilderData;
  @Input() parentObject?;
  isShowing: boolean;
  @Output() emitFormBuilder: EventEmitter<any> = new EventEmitter<any>();
  @Output() itemerror = new EventEmitter<boolean>();
  @ViewChild('sidenav') sidenav;
  parentObjects: any;

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    this.parentObjects = this.parentObject;
  }

  ngOnInit(): void {}

  onDataFormBuilder(sharedFormbuilder) {
    this.emitFormBuilder.emit(sharedFormbuilder);
  }

  onGetItemError($event) {
    this.itemerror.emit($event);
  }
}
